import "./style.scss";
import classNames from "classnames";

export type Colors = "blue" | "violet" | "cyan" | "teal" | "lime" | "yellow" | "coral" | "red" | "base-blue" | "disabled" | "white" | "black" | "transparent";

export interface IconProps {
	src: string;
	alt?: string;
	size?: "small" | "medium" | "large" | "fit";
	id?: string;
	className?: string;
	background?: Colors;
	filter?: Colors;
	containerStyle?: React.CSSProperties;
	iconStyle?: React.CSSProperties;
}

const Icon: React.FC<IconProps> = ({ src, alt, size, id, className, background, filter, containerStyle, iconStyle }: IconProps) => {
	const iconClass = classNames("icon-container", {
		[`size-${size}`]: size,
		[`filter-${filter}`]: filter,
		[`background-${background}`]: background,
		[`${className}`]: className,
	});

	const containerStyles = { ...(containerStyle || {}), ...(background ? { backgroundColor: background } : {}) };

	return (
		<div id={id} className={iconClass} style={containerStyles}>
			<img src={src} alt={alt} style={iconStyle} />
		</div>
	);
};

export default Icon;
